<template>
	<q-select ref="watchlistSelect"
			  :value="searchword"
			  @input="selectWatchlist"
			  use-input
			  hide-selected
			  fill-input
			  input-debounce="500"
			  :label="$t('label.watchlist')"
			  :options.sync="watchlists"
			  option-label="name"
			  @filter="filterWatchlists"
			  :loading="loading"
			  :disable="disable"
	>
		<template v-slot:no-option="scope">
			<div class="q-pa-md">{{ $t('noResults') }}</div>
		</template>
	</q-select>
</template>

<script>
	import {SEARCH_WATCHLISTS} from "@/store/actions.type";

	export default {
		name: "WatchlistSelect",
		props: {
			watchlistName: String,
			customer: {
				type: Object,
				default: null
			},
			disable: {
				type: Boolean,
				default: false
			},
			onlyStatic: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				searchword: this.watchlistName || '',
				watchlists: [],
				loading: false,
				initialLoadDisplay: false
			}
		},
		watch: {
			watchlistName() {
				this.searchword = this.watchlistName || '';
			}
		},
		methods: {
			async filterWatchlists(val, update, abort) {
				await update(async () => {
					const filter = val.toLowerCase().trim(),
						customer = this.customer ? this.customer.entityId : '';

					if (filter.length > 0 || customer.length > 0) {
						this.loading = true;
						this.watchlists = await this.$store.dispatch(SEARCH_WATCHLISTS, {filter, customer, onlyStatic: this.onlyStatic});
						this.loading = false;

						if (!this.initialLoadDisplay) {
							this.$refs.watchlistSelect.showPopup();
							this.initialLoadDisplay = true;
						}
					}
				});
			},
			selectWatchlist(watchlist) {
				this.$emit('input', watchlist);
				this.searchword = watchlist.name;
			}
		}
	}
</script>